import * as screenResolutions from '@Constants/ScreenResolutions';

/**
 * @method isFullView
 * Checks whether the window is in FullView state
 * @returns {boolean}
 */
export const isFullView = () => {
  return window.innerWidth >= screenResolutions.TABLET_RESOLUTION;
};

/**
 * @method isTabletView
 * Checks whether the window is in TabletView state
 * @returns {boolean}
 */
export const isTabletView = () => {
  return window.innerWidth < screenResolutions.TABLET_RESOLUTION;
};

/**
 * @method isStructureEditorBreakpoint
 * Checks whether the window is in Structure Editor breakpoint state (1240px)
 * @returns {boolean}
 */
export const isStructureEditorBreakpoint = () => {
  return window.innerWidth < screenResolutions.STRUCTURE_EDITOR_BREAKPOINT;
};

/**
 * @method isMobileView
 * Checks whether the window is in MobileView state
 * @returns {boolean}
 */
export const isMobileView = () => {
  return window.innerWidth <= screenResolutions.MOBILE_RESOLUTION;
};

/**
 * @method isBreakpointView
 * Checks whether the window is in BreakpointView state (1440px)
 * @returns {boolean}
 */
export const isBreakpointView = () => {
  return window.innerWidth <= screenResolutions.BREAKPOINT_RESOLUTION;
};

/**
 * @method onResize
 * Adds handler for window onResize event
 */
export const onResize = (callback) => {
  window.addEventListener('resize', callback);
  return () => {
    window.removeEventListener('resize', callback);
  };
};
